import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b45a508"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-text-center" }, "Pending Payments", -1))
const _hoisted_3 = { class: "p-text-center" }
const _hoisted_4 = { class: "p-d-flex p-ai-center" }
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "p-text-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h2", _hoisted_3, _toDisplayString(new Date().toLocaleString('default', { month: 'long' })), 1),
    _createVNode(_component_DataTable, {
      header: " ",
      value: $setup.data?.creatorEarnings,
      responsiveLayout: "scroll",
      class: "p-mt-6 w-100"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          header: "Creator",
          field: "photo",
          sortable: false
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_4, [
              (data?.photo)
                ? (_openBlock(), _createBlock(_component_Avatar, {
                    key: 0,
                    image: data?.photo,
                    class: "p-mr-2 photo"
                  }, null, 8, ["image"]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_5, _toDisplayString(data?.name), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Amount",
          field: "amountEarnedThisCycle",
          sortable: false
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_6, _toDisplayString(data?.amountEarnedThisCycle) + " USD", 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_Paginator, {
      onPage: $setup.pageChange,
      rows: 10,
      totalRecords: $setup.totalCount
    }, null, 8, ["onPage", "totalRecords"])
  ]))
}